import { InteractionType } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { loginRequest } from "@configurations/authConfig";
import { ThemeProvider } from "@mui/material/styles";
import { baseTheme } from "./theme";
import AuthenticatedLayout from "./pages/AuthenticatedLayout";
import MsalErrorScreen from "./pages/MsalErrorScreen";
import MsalLoadingScreen from "./pages/MsalLoadingScreen";
import { permissionsApi } from "@features/authorization/authService";
import { Suspense, useEffect } from "react";

export const Layout = () => {
  const { instance } = useMsal();
  const [
    verifyUser,
    {
      isSuccess: userIsVerified,
      isError: userVerificationFailed,
      isLoading: isVerifyingUser,
      isUninitialized: hasNotVerified,
    },
  ] = permissionsApi.useLazyVerifyUserAccessTokenQuery();

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const renderTemplate = () => {
    if (hasNotVerified || isVerifyingUser) {
      return <MsalLoadingScreen />;
    } else if (userVerificationFailed) {
      return <MsalErrorScreen />;
    } else if (userIsVerified) {
      return (
        <AuthenticatedTemplate>
          <AuthenticatedLayout />
        </AuthenticatedTemplate>
      );
    }
    return (
      <UnauthenticatedTemplate>
        <h5 className="card-title">
          Please log in to access Dolphin Automations.
        </h5>
        <div onClick={handleLoginRedirect}>Log in</div>
      </UnauthenticatedTemplate>
    );
  };

  useEffect(() => {
    const account = instance.getActiveAccount();
    if (account && hasNotVerified) {
      verifyUser();
    }
  }, [instance.getActiveAccount()]);

  return (
    <ThemeProvider theme={baseTheme}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        errorComponent={() => <MsalErrorScreen />}
        loadingComponent={() => <MsalLoadingScreen />}
      >
        <div className="App">
          <Suspense fallback={<MsalLoadingScreen />}>
            {renderTemplate()}
          </Suspense>
        </div>
      </MsalAuthenticationTemplate>
    </ThemeProvider>
  );
};
